import React from 'react';
import Dashboard from './Dashboard';
import './styles.css';
import { Link } from 'react-router-dom';

function Scenario() {
  return (
    <div className="page-container">
      <h2>Energy Transition Scenario</h2>
      <p>RTE proposes three nuclear-free scenarios for France's energy transition, each focusing on an increase in renewable energies: a balanced mix, a dominance of wind power, and an emphasis on solar power. 
      The dashboard illustrates the percentages of each renewable energy source required, compares the minerals required with the reserves available, and shows the pollution generated by each scenario. 
      These visualizations help to understand the implications in terms of resources, sustainability and environmental impact.</p>
      <div className="navigation-buttons">
        <Link to="/minerals-extraction" className="arrow-left4">&#8592;</Link>
        <Link to="/energy-and-global-warming" className="arrow-right4">&#8594;</Link>
      </div>
      <div className="content">
        <Dashboard />
      </div>
      <p>Although these scenarios considerably reduce CO2 emissions, they continue to pollute water significantly and use limited resources that will rapidly run out. 
      It is therefore crucial to change our lifestyles to reduce consumption and ensure a truly sustainable energy transition.</p>
      
    </div>
  );
}

export default Scenario;